import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShoppingBag } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  time: string;
}
const purchases: Purchase[] = [{
  name: 'Camila R.',
  city: 'Buenos Aires, AR',
  time: 'hace 2 minutos'
}, {
  name: 'Valentina M.',
  city: 'CDMX, MX',
  time: 'hace 5 minutos'
}, {
  name: 'Sofía L.',
  city: 'Bogotá, CO',
  time: 'hace 8 minutos'
}, {
  name: 'Martina G.',
  city: 'Santiago, CL',
  time: 'hace 11 minutos'
}, {
  name: 'Lucía P.',
  city: 'Lima, PE',
  time: 'hace 13 minutos'
}, {
  name: 'Antonella V.',
  city: 'Córdoba, AR',
  time: 'hace 17 minutos'
}, {
  name: 'Renata S.',
  city: 'Guadalajara, MX',
  time: 'hace 20 minutos'
}, {
  name: 'Florencia B.',
  city: 'Rosario, AR',
  time: 'hace 23 minutos'
}, {
  name: 'Daniela T.',
  city: 'Medellín, CO',
  time: 'hace 26 minutos'
}, {
  name: 'Catalina F.',
  city: 'Quito, EC',
  time: 'hace 29 minutos'
}, {
  name: 'Agustina C.',
  city: 'Montevideo, UY',
  time: 'hace 32 minutos'
}, {
  name: 'Paula H.',
  city: 'Mendoza, AR',
  time: 'hace 35 minutos'
}, {
  name: 'Belén Q.',
  city: 'Valparaíso, CL',
  time: 'hace 38 minutos'
}, {
  name: 'Romina A.',
  city: 'Asunción, PY',
  time: 'hace 41 minutos'
}];
const VISIBLE_MS = 5000;
const GAP_MIN_MS = 12000;
const GAP_MAX_MS = 22000;
function getInitials(name: string): string {
  return name.split(' ').map(n => n.charAt(0)).join('').toUpperCase();
}
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    function showNext() {
      const purchase = purchases[index % purchases.length];
      setCurrent(purchase);
      setIndex(i => i + 1);
      hideTimer = setTimeout(() => {
        setCurrent(null);
        const gap = GAP_MIN_MS + Math.random() * (GAP_MAX_MS - GAP_MIN_MS);
        nextTimer = setTimeout(showNext, gap);
      }, VISIBLE_MS);
    }
    // Initial delay before first notification
    const firstDelay = setTimeout(showNext, 6000);
    return () => {
      clearTimeout(firstDelay);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none max-w-[calc(100vw-2rem)] sm:max-w-sm" data-id="element-222">
      <AnimatePresence data-id="element-223">
        {current && <motion.div key={`${current.name}-${index}`} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-white rounded-2xl shadow-soft-pink border border-brand-pink-light px-3 py-2.5 sm:px-4 sm:py-3 flex items-center gap-3" data-id="element-224">
            {/* Avatar */}
            <div className="shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-brand-pink-light to-brand-pink-mid flex items-center justify-center text-brand-rose font-bold text-sm font-serif" data-id="element-225">
              {getInitials(current.name)}
            </div>

            {/* Content */}
            <div className="min-w-0 flex-1" data-id="element-226">
              <div className="flex items-center gap-1.5" data-id="element-227">
                <span className="font-bold text-sm text-brand-brown truncate" data-id="element-228">
                  {current.name}
                </span>
                <Check size={12} className="text-green-500 bg-green-100 rounded-full p-0.5 shrink-0" strokeWidth={3} data-id="element-229" />
              </div>
              <p className="text-xs text-brand-brown/80 leading-tight flex items-center gap-1" data-id="element-230">
                <ShoppingBag size={11} className="text-brand-rose shrink-0" data-id="element-231" />
                <span className="truncate" data-id="element-232">compró Pretty Pets PRO KIT 💕</span>
              </p>
              <p className="text-[0.65rem] text-brand-brown/50 mt-0.5" data-id="element-233">
                {current.city} · {current.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}